import script from "./RateChangeConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RateChangeConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./RateChangeConfirmationModal.vue?vue&type=style&index=0&id=09bcb31b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bcb31b"]])

export default __exports__